(function() {
  function closeNewsletterPopup() {
    const popup = document.querySelector('.newsletter-popup-modal');
    if (popup) {
      popup.style.display = 'none';
      popup.classList.add('hidden');
      popup.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('newsletter-popup-open');

    const isDesignMode = window.Shopify && window.Shopify.designMode;
    if (!isDesignMode) {
      localStorage.setItem('newsletter_popup_closed', 'true');
      sessionStorage.setItem('newsletter_popup_closed', 'true');
    }
  }

  function showNewsletterPopup() {
    const popup = document.querySelector('.newsletter-popup-modal');
    if (!popup) return;

    popup.classList.remove('hidden');
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('newsletter-popup-open');
    window.scrollTo(0, 0);
  }

  // Handle native form submission: show loading spinner and clean action hash
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('.newsletter-popup-form');
    if (!form) return;

    const input = form.querySelector('.newsletter-popup-form__input');
    const btn = form.querySelector('.js-newsletter-submit-btn');
    const email = input ? input.value.trim() : '';

    if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
      e.preventDefault();
      if (input) {
        input.focus();
        input.style.borderColor = '#8A1C1C';
      }
      return;
    }

    if (btn) {
      btn.classList.add('loading');
      btn.disabled = true;
    }

    // Strip hash from form action so redirect lands cleanly at top of page
    if (form.action && form.action.indexOf('#') !== -1) {
      form.action = form.action.split('#')[0];
    }
  });

  // Global click delegation
  document.addEventListener('click', function(e) {
    if (e.target.closest('.newsletter-popup-modal__close') || e.target.closest('.newsletter-popup-modal__overlay') || e.target.closest('.js-newsletter-okay-btn')) {
      e.preventDefault();
      closeNewsletterPopup();
      return;
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const popup = document.querySelector('.newsletter-popup-modal');
      if (popup && popup.style.display === 'flex') {
        closeNewsletterPopup();
      }
    }
  });

  function initNewsletterPopup() {
    const popup = document.querySelector('.newsletter-popup-modal');
    if (!popup) return;

    const isDesignMode = window.Shopify && window.Shopify.designMode;

    // Show success popup ONLY after Shopify confirms form was posted successfully
    if (window.__newsletterJustSubscribed) {
      if (window.location.hash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
      window.scrollTo(0, 0);

      const subheading = popup.querySelector('.newsletter-popup-tag__subheading');
      const formContent = popup.querySelector('.newsletter-popup-form-content');
      const successState = popup.querySelector('.newsletter-popup-success-state');
      const successMsg = popup.querySelector('.newsletter-popup-form__message--success');

      if (subheading) subheading.style.display = 'none';
      if (formContent) formContent.style.display = 'none';
      if (successMsg) successMsg.textContent = 'We’ll be staying in touch!';
      if (successState) successState.style.display = 'flex';

      showNewsletterPopup();
      window.scrollTo(0, 0);

      if (!isDesignMode) {
        localStorage.setItem('newsletter_popup_subscribed', 'true');
        localStorage.setItem('newsletter_popup_closed', 'true');
        sessionStorage.setItem('newsletter_popup_closed', 'true');
      }
      return;
    }

    if (!isDesignMode && popup.classList.contains('hidden')) {
      return;
    }

    // Do not show if user already subscribed or closed popup
    if (!isDesignMode) {
      if (
        localStorage.getItem('newsletter_popup_subscribed') === 'true' ||
        localStorage.getItem('newsletter_popup_closed') === 'true' ||
        sessionStorage.getItem('newsletter_popup_closed') === 'true'
      ) {
        return;
      }
    }

    const delaySec = isDesignMode ? 0 : parseInt(popup.getAttribute('data-delay') || '2', 10);

    if (!isDesignMode) {
      if (delaySec === 0) {
        showNewsletterPopup();
      } else {
        setTimeout(showNewsletterPopup, delaySec * 1000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }

  // Theme Editor events
  document.addEventListener('shopify:section:select', function(event) {
    const popup = document.querySelector('.newsletter-popup-modal');
    if (!popup) return;

    const sectionId = event.detail ? event.detail.sectionId : '';
    if (sectionId && sectionId.includes('newsletter_popup')) {
      showNewsletterPopup();
    } else {
      closeNewsletterPopup();
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const sectionId = event.detail ? event.detail.sectionId : '';
    if (sectionId && sectionId.includes('newsletter_popup')) {
      closeNewsletterPopup();
    }
  });
})();
